import chroma from 'chroma-js';

export const getColorHexValue = (id, opacity = 1, useTransparency = false) => {
	const bodyColorValue = getComputedStyle(document.body).getPropertyValue(`--color-body`);
	const baseColorValue = getComputedStyle(document.body).getPropertyValue(`--color-${id}`);

	if (useTransparency) {
		return chroma(baseColorValue).alpha(opacity).hex();
	} else {
		return chroma(baseColorValue)
			.mix(bodyColorValue, 1 - opacity)
			.hex();
	}
};
